<template>
  <div class="integration-select">
    <div v-if="options.title" class="title">
      <!-- <span v-if="integrationDataState.length == 1"
                >{{ $t("dialog.add_number.integration_default") }}:</span
            > -->
      <span>{{ $t("dialog.add_number.title_second") }}</span>
    </div>
    <transition name="fade">
      <div class="integration-select-content">
        <component
          :is="readonly ? 'div' : 'button'"
          v-for="crm in integrationDataState"
          :key="crm.name"
          :type="readonly ? undefined : 'button'"
          class="select-integration-component"
          :class="{ active: !readonly && system === crm.name, readonly }"
          @click="!readonly && selectIntegration(crm.name)"
        >
          <img
            class="image"
            :class="{ svg: crm.svg, 'no-padding': crm.noPadding }"
            :src="imagePath(crm.name, crm.svg)"
            :alt="crm.name"
          />
          <div class="title">{{ crm.name }}</div>
        </component>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { INTEGRATION_DATA } from "@/data/integrationData.js";

const system = ref("");
const loading = ref(false);

const props = defineProps({
  options: {
    type: Object,
  },
  filter: {
    type: String,
    default: "",
  },
  isOpening: {
    type: Boolean,
    default: false,
  },
  // show the integrations as a plain list: nothing to pick, nothing to hover
  readonly: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["selectIntegration"]);

const integrationDataState = computed(() => {
  const filterCrm = !props.filter
    ? INTEGRATION_DATA
    : INTEGRATION_DATA?.filter((crm) => crm.filters?.includes(props.filter));
  if (filterCrm.length === 1 && !props.isOpening && !props.readonly) {
    selectIntegration(filterCrm[0].name);
  }
  return filterCrm;
});

const imagePath = (name, svg = false) => {
  try {
    return require(`@/assets/images/integrations/${
      svg ? `${name}.svg` : `${name}.png`
    }`).default;
  } catch (error) {
    return false;
  }
};

const selectIntegration = (crmName) => {
  system.value = crmName;
  emits("selectIntegration", crmName);
};
</script>

<style lang="scss" scoped>
.flex-wrap-nowrap {
  flex-wrap: nowrap;
}

.flex-wrap-wrap {
  flex-wrap: wrap;
}

.integration-select {
  display: flex;
  flex-direction: column;
  gap: 19px;
  margin-bottom: auto;
  .title {
    font-family: Gilroy;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    color: #404040ff;

    .titleError {
      color: var(--danger-second-color);
    }
  }

  .integration-select-content {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    max-height: calc(100dvh - 490px);
    overflow-y: auto;
  }
}

.perfectum {
  height: 78px;
}

.select-integration-component {
  width: 125px;
  height: 115px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  padding-bottom: 16px;
  box-sizing: border-box;
  border-radius: 11px;
  border: 1px solid transparent;
  background-color: var(--block-color);
  transition: 0.4s;

  &:hover {
    cursor: pointer;
    border: 1px solid #7a70df;
  }

  // keeps the hover highlight, only the pointer and the picking are gone
  &.readonly:hover {
    cursor: default;
  }

  &.active {
    cursor: default;
    // padding: 0;
    border-color: #7a70dfff;
    transition: 0.4s;

    .title {
      padding-bottom: 0;

      span {
        color: #7a70dfff;
        transition: 0.4s;
      }
    }
  }

  .title {
    font-family: Gilroy;
    font-size: 10px;
    font-weight: 500;
    margin-top: 5px;
    padding-bottom: 0;
    color: black;
    transition: 0.4s;
  }

  .image {
    max-width: calc(100% - 20px);
    position: relative;
    top: 15px;
    right: 0;
    margin: auto;
  }
  .svg {
    padding: 0 10px;
  }
  // wide wordmarks: drop the svg inset so they match the width of wide PNG logos
  .no-padding {
    padding: 0;
    width: 100px;
  }
}
.no_logo {
  margin-bottom: 12px;
  font-size: large;
  text-transform: uppercase;
  font-weight: 700;
}
</style>
